import React from 'react';
import qs from 'qs';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { CmsPageTypeRoutes } from '@reverbdotcom/commons/src/url_helpers';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { CmsPageType } from '@reverbdotcom/commons/src/constants';

const lazyDynamicPage = async () => ({
  Component: (await import(
    /* webpackChunkName: 'cms' */
    '@reverbdotcom/commons/src/components/dynamic_page'
  )).default,
});

function buildRoute(prefix, cmsPageType) {
  const suffix = cmsPageType === CmsPageType.SEO_LANDING_PAGE ? '/*' : '/:slug/:childSlug?';
  const path = `${prefix}${suffix}`;

  return (
    <Route
      path={path}
      key={path}
      handle={{
        cmsPageType,
        clientSide: true,
      }}
      lazy={lazyDynamicPage}
    />
  );
}

function buildRootRoute(prefix) {
  if (prefix === CmsPageTypeRoutes.promo) {
    // /promo is not actually a CMS route, just using it for tracking
    return (
      <Route
        path={prefix}
        key={prefix}
        handle={{
          clientSide: false,
          pageViewEvent: (routerState) => ({
            pageName: MParticlePageName.RedeemPromoCode,
            prefilled: !!qs.parse(routerState.location.search, { ignoreQueryPrefix: true }).token,
          }),
        }}
      />
    );
  }

  return (
    <Route
      path={prefix}
      key={prefix}
      handle={{
        cmsPageType: 'root',
        slugOverride: prefix,
        clientSide: true,
      }}
      lazy={lazyDynamicPage}
    />
  );
}

function buildAll() {
  const routes = [];

  Object.keys(CmsPageTypeRoutes).forEach((pageType) => {
    const prefix = CmsPageTypeRoutes[pageType];

    routes.push(
      buildRoute(prefix, pageType),
      buildRootRoute(prefix),
    );
  });

  return routes;
}

export const CmsRoutes = buildAll();
